import { GET_GOVBR_MENU } from '../../constants/ActionTypes';

const initialState = {
  items: [],
  loading: false,
  error: null,
  loaded: false,
};

function normalizeMenu(items) {
  // Garante que items seja sempre um array
  const safeItems = Array.isArray(items) ? items : [];
  return safeItems.map((item, idx) => ({
    '@id': `${item.Title}-${idx}`,
    title: item.Title,
    url: item.getURL,
    items: item.children ? normalizeMenu(item.children) : [],
  }));
}

const govbr_menu = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_GOVBR_MENU}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_GOVBR_MENU}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        items: normalizeMenu(action.result),
      };
    case `${GET_GOVBR_MENU}_FAIL`:
      return {
        ...state,
        loaded: true,
        loading: false,
        items: [],
        error: action.result,
      };
    default:
      return state;
  }
};

export default govbr_menu;
